import { CreateQConfigForm } from '@exam-management/qconfig-list';
import { useModalNavigation, useParams } from '@exam-management/router';
import { Dialog, DialogTitle, Divider } from '@shared/components';

export default function CreateQConfigModal() {
  const { courseId } = useParams('/exam-courses/:courseId/qconfigs');

  const { current, close } = useModalNavigation(
    '/exam-courses/:courseId/qconfigs',
    '/create-qconfig',
    {
      close: {
        params: { courseId },
      },
    },
  );

  const onClose = () => {
    close();
  };

  return (
    <Dialog open={current === '/create-qconfig'} maxWidth='sm' onClose={onClose}>
      <DialogTitle onClose={onClose}>Create QConfig</DialogTitle>
      <Divider />
      <CreateQConfigForm onClose={onClose} />
    </Dialog>
  );
}
